import type { CMSAccordionContainerDTO } from "~/features/cms/types/dto";
import { useCMSComponentRenderer } from "~/features/cms/CMSComponentRendererContext";
import { AccordionGroup, AccordionGroupTitle } from "~/common/mui/Accordion/AccordionGroup";

interface Props extends Omit<CMSAccordionContainerDTO, "type"> {
  className?: string;
}

export const CMSAccordionContainer = (props: Props) => {
  const renderCMSComponent = useCMSComponentRenderer();
  return (
    <AccordionGroup>
      <AccordionGroupTitle>{props.title}</AccordionGroupTitle>
      {props.accordionItems.map((accordion, index) => {
        return renderCMSComponent(accordion, undefined, index);
      })}
    </AccordionGroup>
  );
};
